export type LastNameMismatch = { valueAtNhs: string; valueAtMiPro: string };

export type DateOfBirthMismatch = { valueAtNhs: Date; valueAtMiPro: Date };

export class DateOfBirthMismatchNormalized {
    private _valueAtNhs: string;
    private _valueAtMiPro: string;

    constructor(private dobMismatch: DateOfBirthMismatch) {}

    private formatDate(date?: Date) {
        if (!date) {
            return "";
        }

        return `${date.getDate().toString().padStart(2, "0")}/${(date.getMonth() + 1).toString().padStart(2, "0")}/${date.getFullYear()}`;
    }

    get valueAtNhs() {
        return this._valueAtNhs ?? (this._valueAtNhs = this.formatDate(this.dobMismatch?.valueAtNhs));
    }

    get valueAtMiPro() {
        return this._valueAtMiPro ?? (this._valueAtMiPro = this.formatDate(this.dobMismatch?.valueAtMiPro));
    }
}

export type MismatchData = { lastNameMismatch?: LastNameMismatch; dateOfBirthMismatch?: DateOfBirthMismatch };
